export const urls = {
  GET_DOKUMENT: 'Dokumenta/vrati_dokumenta_objekta',
};
